module.exports = __webpack_public_path__ + "static/media/FW 1.31881234.jpg";